const swiperPerguntas = new Swiper(".swiper-perguntas", {
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    speed: 1000,
    grabCursor: true,
});

const btnAskPrev = document.querySelector('.btn-prev');
const btnAskNext = document.querySelector('.btn-next');

if (btnAskPrev) {
    btnAskNext.addEventListener('click', function () {
        swiperPerguntas.slideNext();
        console.log('next')
    });
    btnAskPrev.addEventListener('click', function () {
        swiperPerguntas.slidePrev();
        console.log('prev')
    })
}



  // swiper download mobile

const swiperCards = new Swiper(".swiperCard", {
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    speed: 1000,
    grabCursor: true,
});

const btnDownloadPrev = document.querySelector('.btn-prev-card');
const btnDownloadNext = document.querySelector('.btn-next-card');

if (btnDownloadPrev) {
    // Button click event listener
    btnDownloadNext.addEventListener('click', function () {
     swiperCards.slideNext();
    });
    btnDownloadPrev.addEventListener('click', function () {
     swiperCards.slidePrev();
    })
}